export const ON = 'ON';
export const CONTROL = 'CONTROL';

export const TREATMENT_TYPES = {
  ON,
  CONTROL,
};
